import type { WorkspaceSetting } from '@workspace/domain/workspace';
import type { ViewModelIndividualPermissionRoleJSON, WorkspaceMemberRoleJSON } from 'balus-common';
import { ViewModelSharingUserRoleType } from './vo/ViewModelSharingUserRoleType';

type Params = {
  workspaceSetting: WorkspaceSetting;
  workspaceMemberRole: WorkspaceMemberRoleJSON | null;
  viewModelTrashedAt: string | null;
  viewModelSharingUserRoleType: ViewModelSharingUserRoleType;
  groupEnableIndividualViewModelPermissions: boolean;
  individualPermissionRole: ViewModelIndividualPermissionRoleJSON | null;
};

// rules.boltのcanReadViewModelも参照
export const canReadViewModel = ({
  workspaceMemberRole,
  workspaceSetting,
  viewModelSharingUserRoleType,
  viewModelTrashedAt,
  groupEnableIndividualViewModelPermissions,
  individualPermissionRole,
}: Params): boolean => {
  const { isPublicSpace, isViewModelURLShareable, enableIndividualViewModelPermissions } = workspaceSetting;

  // 削除されているviewModel
  // 削除されているviewModelは、管理者か編集者のみ読み取り可能
  if (viewModelTrashedAt) {
    return !!workspaceMemberRole && ['admin', 'editor'].includes(workspaceMemberRole);
  }

  // 削除されていないviewModel
  // いずれかのworkspaceロールが割り当てられていたら読み取り可能
  if (workspaceMemberRole) {
    return true;
  }

  // 公開ワークスペースなら読み取り可能
  if (isPublicSpace) {
    return true;
  }

  // URL共有の設定が有効で、かつviewModel共有ロールが割り当てられているなら読み取り可能
  if (isViewModelURLShareable && viewModelSharingUserRoleType !== ViewModelSharingUserRoleType.None) {
    return true;
  }

  // グループでのビューモデル個別権限設定と、ワークスペースでのビューモデル個別権限設定が有効な場合に、
  // 対象ビューモデルに対して権限付与がされている場合には、読み取り可能
  if (groupEnableIndividualViewModelPermissions && enableIndividualViewModelPermissions && individualPermissionRole) {
    return true;
  }

  // いずれにも合致しないときは、読み取り不可
  return false;
};
